import { defineStore } from "pinia";
import { ref } from "vue";

export const useAppStore = defineStore("app", () => {
  const isLoading = ref(false);
  const deferredPrompt = ref(null);
  const isAppInstalled = ref(false);
  const appInfo = ref(null);

  return { isLoading, deferredPrompt, isAppInstalled, appInfo };
});
